import { Body } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { LocalizedDateFromUtc, LocalizedShortTimeFromUtc, LocalizedSmallParagraph } from '@mews-commander/ui';
import { DetailedPlatformProfileResult } from '@mews-commander/data-access';
import { PlatformProfileDetailsSection, PlatformProfileDetailsSectionItem } from './PlatformProfileDetailsSection';

export const PlatformProfileActivityMetaData = ({
    platformProfile,
}: {
    platformProfile: DetailedPlatformProfileResult;
}) => (
    <PlatformProfileDetailsSection textKey={TextKey.Activity}>
        <MetaDataItem labelTextKey={TextKey.UpdatedOn} dateTimeString={platformProfile.activityLog.updatedAtUtc} />
        <MetaDataItem labelTextKey={TextKey.CreatedOn} dateTimeString={platformProfile.activityLog.createdOnUtc} />
    </PlatformProfileDetailsSection>
);

const MetaDataItem = ({
    dateTimeString,
    labelTextKey,
}: {
    dateTimeString?: string | null;
    labelTextKey: Mews.TextKey;
}) => (
    <PlatformProfileDetailsSectionItem>
        <LocalizedSmallParagraph variant="secondary" textKey={labelTextKey} />
        <Body size="small">
            {dateTimeString ? (
                <>
                    <LocalizedDateFromUtc utcString={dateTimeString} />{' '}
                    <LocalizedShortTimeFromUtc utcString={dateTimeString} />
                </>
            ) : (
                UnicodeEntity.Dash
            )}
        </Body>
    </PlatformProfileDetailsSectionItem>
);
